module.exports = __webpack_public_path__ + "static/img/Tom_Rockliff_desktop.4eccc0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Rockliff_desktop.jpg
// module id = OBPU
// module chunks = 0